import React from 'react';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import TextField from '@material-ui/core/TextField';
import Button from "@material-ui/core/Button";
import { deleteAPolice, loadPoliceData, saveAPolice, updateAPolice, clearPoliceErrorMsg } from "../../redux/modules/police";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import { bindActionCreators } from "redux";
//import {loadCamerasData} from "../../redux/modules/camera";
import { withStyles } from "@material-ui/core";
import DynamicTable from "./DynamicTable";
import FormControl from "@material-ui/core/FormControl";
import InputLabel from "@material-ui/core/InputLabel";
import Select from "@material-ui/core/Select";
import MenuItem from "@material-ui/core/MenuItem";
import GridList from "@material-ui/core/GridList";
import CardVehicleInformation from "./CardVehicleInformation";
import CardPoliceInformation from "./CardPoliceInformation";
import ExpandablePoliceInformation from "./ExpandablePoliceInformation";
import FormHelperText from '@material-ui/core/FormHelperText';
import { loadCompanysData } from "../../redux/modules/company";
import CardCompanyInformation from "./CardCompanyInformation";
import * as MainConstants from "../../utils/MainConstants";
import ExpandableTowJobInformation from "./ExpandableTowJobInformation";
import { DEFAULT_VESPAAN_SERVER } from "../../utils/MainConstants";
import InputMask from 'react-input-mask'
import Dialog from "@material-ui/core/Dialog";
import DialogTitle from "@material-ui/core/DialogTitle";
import DialogContent from "@material-ui/core/DialogContent";
import DialogActions from "@material-ui/core/DialogActions";
//import CardPoliceInformation from "./CardPoliceInformation";
//import {loadLocationsData} from "../../redux/modules/location";


const styles = theme => ({
    main: {
        width: 'auto',
        display: 'block', // Fix IE 11 issue.
        marginLeft: theme.spacing.unit * 3,
        marginRight: theme.spacing.unit * 3,
        [theme.breakpoints.up(400 + theme.spacing.unit * 3 * 2)]: {
            width: 400,
            marginLeft: 'auto',
            marginRight: 'auto',
        },
    },
    paper: {
        marginTop: theme.spacing.unit * 8,
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        padding: `${theme.spacing.unit * 2}px ${theme.spacing.unit * 3}px ${theme.spacing.unit * 3}px`,
    },
    avatar: {
        margin: theme.spacing.unit,
        backgroundColor: theme.palette.secondary.main,
    },
    form: {
        width: '100%', // Fix IE 11 issue.
        marginTop: theme.spacing.unit,
    },
    submit: {
        marginTop: theme.spacing.unit * 3,
    },
    formControl: {
        margin: theme.spacing.unit,
        minWidth: 120,
    },
    selectEmpty: {
        marginTop: theme.spacing.unit * 2,
    },
    button: {
        marginTop: theme.spacing.unit * 3,
        marginLeft: theme.spacing.unit,
        backgroundColor: "#e2580d",
        color: "black",
        textTransform: "unset !important",
        width: '80%',
    },
    gridList: {
        width: '80%',
        height: '95%',
        maxHeight: 800,
    },
});


/*
private String id;
    private String ein;
    private String userId;
    private String name;
    private String address1;
    private String address2;
    private String city;
    private String state;
    private String country;
    private String zipCode;
    private String type;
    private String phone;
    private String email;
 */

class PoliceInfoForm extends React.Component {
    
    
    state = {
        
        //selectedLocation:{},
        selectedPolice: { "id":"", "country": "U.S.A", "state": "Massachusetts" },
        selectedCompany: {},
        inputFieldShrinkState: true,
        numberShrink: false, //Jut sfor alter I can add a shrink flag for each filed.
        showPoliceSavedDialog: false
        
    };
    
    
    
    
    constructor(props) {
        super(props);
        this.policeCardList = null;
        //this.companySelectList=null;
        
        this.editRecord = this.editRecord.bind(this);
        this.deleteRecord = this.deleteRecord.bind(this);
        this.clearFields = this.clearFields.bind(this);
        this.refresh = this.refresh.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
        this.handleUpdate = this.handleUpdate.bind(this);
        //this.handlePoliceNumberChange = this.handlePoliceNumberChange.bind(this);
        this.handleNameChange = this.handleNameChange.bind(this);
        this.handleAddress1Change = this.handleAddress1Change.bind(this);
        //this.handleBankNameChange = this.handleBankNameChange.bind(this);
        
        this.handleAddress2Change = this.handleAddress2Change.bind(this);
        
        this.handleCityChange = this.handleCityChange.bind(this);
        this.handleStateChange = this.handleStateChange.bind(this);
        this.handleCountryChange = this.handleCountryChange.bind(this);
        this.handleZipcodeChange = this.handleZipcodeChange.bind(this);
        this.handleEmailChange = this.handleEmailChange.bind(this);
        this.handleLocationChange = this.handleLocationChange.bind(this);
        this.handleDepartmentNameChange = this.handleDepartmentNameChange.bind(this);
        
        this.handleFaxChange = this.handleFaxChange.bind(this);
        this.handleTypeChange = this.handleTypeChange.bind(this);
        this.handleTimeZoneChange = this.handleTimeZoneChange.bind(this);
        this.handleLogoChange = this.handleLogoChange.bind(this);
        this.handleWebChange = this.handleWebChange.bind(this);
        this.handleCompanyChange = this.handleCompanyChange.bind(this);
        this.handlePhoneChange = this.handlePhoneChange.bind(this);
        this.getListOfPoliceInformation = this.getListOfPoliceInformation.bind(this);
        this.handleClickShowSavedPolice = this.handleClickShowSavedPolice.bind(this);
        this.handleClickShowSavedPoliceClose = this.handleClickShowSavedPoliceClose.bind(this);
        this.checkFieldsForBlank = this.checkFieldsForBlank.bind(this);
        
        
        
        
        
        
        
        
    }
    
    
    handleClickShowSavedPolice() {
        this.setState({ showPoliceSavedDialog: true });
    };
    
    
    handleClickShowSavedPoliceClose() {
        let { clearPoliceErrorMsg } = this.props;
        this.setState({ showPoliceSavedDialog: false });
        clearPoliceErrorMsg();
    };
    
    handleSubmit() {
        
        
        let { saveAPolice } = this.props;
        
        var tempStream = this.state.selectedPolice;
        
        let checkFieldsResult = this.checkFieldsForBlank(tempStream);
        if((checkFieldsResult === -1)){
            return;
        }
        tempStream.companyid = this.state.selectedCompany.id;
        saveAPolice(DEFAULT_VESPAAN_SERVER.url, tempStream, this.state.selectedCompany.id);
        //this.refresh();
        
    };
    
    
    checkFieldsForBlank(argPoliceFields){
        
        if(argPoliceFields !== null ){
            
            if( (argPoliceFields.chiefname == null)||(argPoliceFields.chiefname ==="")){
                alert("Please enter the Police Chief Name" );
                return -1;
            }
            if( (argPoliceFields.departmentname == null)||(argPoliceFields.departmentname ==="")){
                alert("Please enter the Department Name" );
                return -1;
            }
            if( (argPoliceFields.address1 == null)||(argPoliceFields.address1 ==="")){
                alert("Please enter the Address Line 1" );
                return -1;
            }
            /*if( (tempStream.address2 == null)||(tempStream.address2 =="")){
                alert("Please enter the Department Name" );
                return;
            }*/
            if( (argPoliceFields.city == null)||(argPoliceFields.city ==="")){
                alert("Please enter the City" );
                return -1;
            }
            if( (argPoliceFields.zipcode == null)||(argPoliceFields.zipcode ==="")){
                alert("Please enter the Zipcode" );
                return -1;
            }
            if( (argPoliceFields.phone == null)||(argPoliceFields.phone ==="")){
                alert("Please enter the Phone" );
                return -1;
            }
            
            if( (argPoliceFields.fax == null)||(argPoliceFields.fax ==="")){
                alert("Please enter the Fax" );
                return -1;
            }
            if( (argPoliceFields.country == null)||(argPoliceFields.country ==="")){
                alert("Please enter the Country" );
                return-1;
            }
            
            if( (argPoliceFields.email == null)||(argPoliceFields.email ==="")){
                alert("Please enter the Email" );
                return -1;
            }
            if( (argPoliceFields.state == null)||(argPoliceFields.state ==="")){
                alert("Please enter the State" );
                return -1;
            }
            
        }else{
            alert("Please enter the fields" );
            return -1;
        }
        
        return 0;
    }
    handleUpdate() {
        let { updateAPolice } = this.props;
        
        var tempStream = this.state.selectedPolice;
        //tempStream.locationId= this.state.selectedLocation.id;
        if ((tempStream.address2 == null) || (tempStream.address2.length == 0)) {
            tempStream.address2 = "  ";
        }
        updateAPolice(DEFAULT_VESPAAN_SERVER.url, tempStream, this.state.selectedCompany.id);
        //this.refresh();
        
    };
    
    handleZipcodeChange(event) {
        //event.preventDefault();
        this.setState(Object.assign(this.state.selectedPolice, { zipcode: event.target.value }));
    }
    handleCountryChange(event) {
        //event.preventDefault();
        this.setState(Object.assign(this.state.selectedPolice, { country: event.target.value }));
    }
    
    handleStateChange(event) {
        //event.preventDefault();
        this.setState(Object.assign(this.state.selectedPolice, { state: event.target.value }));
    }
    
    
    handleCityChange(event) {
        //event.preventDefault();
        this.setState(Object.assign(this.state.selectedPolice, { city: event.target.value }));
    }
    
    handleAddress2Change(event) {
        //event.preventDefault();
        this.setState(Object.assign(this.state.selectedPolice, { address2: event.target.value }));
    }
    
    handleAddress1Change(event) {
        //event.preventDefault();
        this.setState(Object.assign(this.state.selectedPolice, { address1: event.target.value }));
    }
    
    /* handlePoliceNumberChange(event) {
         //event.preventDefault();
         this.setState(Object.assign(this.state.selectedPolice,{firstName:event.target.value}));
     }
         */
    
    handleNameChange(event) {
        //event.preventDefault();
        this.setState(Object.assign(this.state.selectedPolice, { chiefname: event.target.value }));
    }
    
    /*handlePoliceNameChange(event) {
        //event.preventDefault();
        this.setState(Object.assign(this.state.selectedPolice,{accountName:event.target.value}));
    }*/
    
    handleEmailChange(event) {
        //event.preventDefault();
        this.setState(Object.assign(this.state.selectedPolice, { email: event.target.value }));
    }
    
    /// handleCompanyChange
    handleCompanyChange(event) {
        let { loadPoliceData } = this.props;
        //event.preventDefault();
        this.setState({ selectedCompany: event.target.value });
        loadPoliceData(DEFAULT_VESPAAN_SERVER.url, event.target.value.id);
    }
    
    handleDepartmentNameChange(event) {
        //event.preventDefault();
        this.setState(Object.assign(this.state.selectedPolice, { departmentname: event.target.value }));
        this.setState({ numberShrink: true });
    }
    
    handleFaxChange(event) {
        //event.preventDefault();
        this.setState(Object.assign(this.state.selectedPolice, { fax: event.target.value }));
        this.setState({ numberShrink: true });
    }
    handleTypeChange(event) {
        //event.preventDefault();
        this.setState(Object.assign(this.state.selectedPolice, { type: event.target.value }));
        this.setState({ numberShrink: true });
    }
    handleTimeZoneChange(event) {
        //event.preventDefault();
        this.setState(Object.assign(this.state.selectedPolice, { timezone: event.target.value }));
        this.setState({ numberShrink: true });
    }
    handleLogoChange(event) {
        //event.preventDefault();
        this.setState(Object.assign(this.state.selectedPolice, { companylogolink: event.target.value }));
        this.setState({ numberShrink: true });
    }
    handleWebChange(event) {
        //event.preventDefault();
        this.setState(Object.assign(this.state.selectedPolice, { webpagelink: event.target.value }));
        this.setState({ numberShrink: true });
    }
    
    handlePhoneChange(event) {
        //event.preventDefault();
        this.setState(Object.assign(this.state.selectedPolice, { phone: event.target.value }));
    }
    
    
    
    
    
    handleLocationChange(event) {
        //event.preventDefault();
        this.setState({ selectedLocation: event.target.value });
        //this.setState({selectedVideoControllerName: event.target.value.displayName});
    }
    
    
    clearFields = (e) => {
        e.preventDefault();
        this.setState(state => ({
            inputFieldShrinkState: true
        }));
        
        
        var tempSelectedPolice = Object.assign({}, this.state.selectedPolice);
        Object.keys(tempSelectedPolice).map((key, index) => {
            tempSelectedPolice[key] = "";
        });
        console.log("Farshid the police is ");
        console.log(tempSelectedPolice);
        this.setState({ selectedPolice: tempSelectedPolice })
        
        
        
        
    };
    renderErrorFiled(data) {
    
    
    }
    
    refresh(event) {
        let { loadPoliceData } = this.props;
        loadPoliceData(DEFAULT_VESPAAN_SERVER.url, this.state.selectedCompany.id);
    }
    
    getListOfCompanies() {
        let tempArray = this.props.policeArray;
        let returnArray = [];
        if (tempArray) {
            returnArray = tempArray.map((s) => {
                s.editMode = false;
                return (<CardPoliceInformation info={s} onEdit={this.editRecord} onDelete={this.deleteRecord}></CardPoliceInformation>);
            });
        }
        return (returnArray);
    }
    
    //This is for making teh police cards expanadble.
    getListOfPoliceInformation() {
        let tempArray = this.state.policeArray; //this.props.towjobsArray;
        let returnArray = [];
        if (tempArray) {
            returnArray = tempArray.map((s) => {
                s.editMode = false;
                /* return(

                     <CardTowJobInformation info={s}  onEdit={this.editRecord}  onDelete={this.deleteRecord}></CardTowJobInformation>
                  );
         });*/
                return (<ExpandablePoliceInformation info={s} key={s.id} onEdit={this.editRecord} onVehicleOwnerText={this.vehicleOwnerTextMode} onTowAgentText={this.towAgentTextMode} onDelete={this.deleteRecord}></ExpandablePoliceInformation>);
            });
            //Duplicating array for testing only.
            //returnArray = returnArray.concat(returnArray);
            
        }
        return (returnArray);
    }
    
    
    getListOfCompaniesForSelection() {
        let tempArray = this.props.companysArray;
        let returnArray = [];
        if (tempArray) {
            returnArray = tempArray.map((s) => {
                return (<MenuItem key={s.id} value={s}>{s.name}</MenuItem>);
                //return(<CardCompanyInformation info={s}  onEdit={this.editRecord}  onDelete={this.deleteRecord}></CardCompanyInformation> );
            });
        }
        return (returnArray);
    }
    
    
    render() {
        const { classes } = this.props;
        this.policeCardList = this.getListOfPoliceInformation(); //this.getListOfCompanies();
        this.companySelectList = this.getListOfCompaniesForSelection();
        let usStates = MainConstants.getUSStates();
        let canStates = MainConstants.getCanadaStates();
        let availableCountries = MainConstants.getCountries();
        return (
          <React.Fragment>
              <Typography variant="h6" gutterBottom>
                  Police Information
              </Typography>
              <Grid container spacing={24}>
                  <Grid item xs={12} sm={12}>
                      
                      <Grid container >
                          
                          <Grid item xs={6} sm={6}>
                              {/* < FormControl className = {classes.formControl}  required fullWidth >
                    < InputLabel htmlFor = "age-simple" > Location < /InputLabel>
                        < Select ref = {c => this.mySelect = c} value = {this.state.selectedLocation} onChange = {this.handleLocationChange}
                        inputProps = { { name: 'location', id : 'location', } } >
                        {this.props.locationsArray.map(n => (<MenuItem value= {n}   ref={n.id} inputProps = { { name: n.id , id :n.id  } } >{n.name}</MenuItem>))}

                        < /Select>
                < /FormControl>
                */}
                              
                              {/*
                                    <Grid container >
                                        <Grid item xs={5} sm={5} >
                                            <TextField required id="number" name="number"  label="Number"  fullWidth  InputLabelProps={{ shrink: this.state.inputFieldShrinkState || this.state.numberShrink  }}  value={this.state.selectedPolice.accountNumber} onChange={this.handleNumberChange}/>
                                        </Grid>
                                        <Grid item xs={2} sm={2} >
                                        </Grid>
                                        <Grid item xs={5} sm={5} >
                                            <TextField required id="name" name="name"  label="Name on the account"  fullWidth  InputLabelProps={{ shrink: this.state.inputFieldShrinkState }}  value={this.state.selectedPolice.accountName} onChange={this.handlePoliceNameChange}/>
                                        </Grid>
                                    </Grid>
                                    */}
                              
                              <Grid container >
                                  <Grid item xs={4} sm={4}>
                                      <TextField required id="chiefname" name="chiefname" label="Chief Name" fullWidth InputLabelProps={{ shrink: this.state.inputFieldShrinkState }} value={this.state.selectedPolice.chiefname} onChange={this.handleNameChange} />
                                  </Grid>
                                  <Grid item xs={1} sm={1}>
                                  </Grid>
                                  
                                  <Grid item xs={4} sm={4} >
                                      <TextField required id="departmentname" name="departmentname" label="Department Name" fullWidth InputLabelProps={{ shrink: this.state.inputFieldShrinkState }} value={this.state.selectedPolice.departmentname} onChange={this.handleDepartmentNameChange} />
                                  </Grid>
                                  <Grid item xs={1} sm={1}>
                                  </Grid>
                                  <Grid item xs={2} sm={2}>
                                      <FormControl className={classes.formControl}>
                                          <InputLabel htmlFor="age-helper"> Select Tow Company </InputLabel>
                                          <Select
                                            value={this.state.selectedCompany}
                                            onChange={this.handleCompanyChange}
                                            useDefault={true}
                                            defaultValue={this.state.selectedCompany.name}
                                          >
                                              
                                              {this.companySelectList}
                                          
                                          </Select>
                                          {/* <FormHelperText>Select a Company </FormHelperText>  */}
                                      </FormControl>
                                  </Grid>
                              </Grid>
                              
                              <Grid item xs={12}>
                                  <TextField required id="address1" name="address1" label="Address line 1" fullWidth InputLabelProps={{ shrink: this.state.inputFieldShrinkState }} value={this.state.selectedPolice.address1} onChange={this.handleAddress1Change} />
                              </Grid>
                              <Grid item xs={12}>
                                  <TextField id="address2" name="address2" label="Address line 2" fullWidth InputLabelProps={{ shrink: this.state.inputFieldShrinkState }} value={this.state.selectedPolice.address2} onChange={this.handleAddress2Change} />
                              </Grid>
                              <Grid container >
                                  <Grid item xs={5} sm={5} >
                                      <TextField required id="city" name="city" label="City" fullWidth InputLabelProps={{ shrink: this.state.inputFieldShrinkState }} value={this.state.selectedPolice.city} onChange={this.handleCityChange} />
                                  </Grid>
                                  <Grid item xs={2} sm={2} >
                                  </Grid>
                                  <Grid item xs={5} sm={5} >
                                      {/*<TextField id="state" name="state" label="State/Province/Region" fullWidth InputLabelProps={{ shrink: this.state.inputFieldShrinkState }}  value={this.state.selectedPolice.state} onChange={this.handleStateChange}/>
                                */}   <FormControl className={classes.formControl}>
                                      <InputLabel htmlFor="age-helper">State</InputLabel>
                                      <Select value={this.state.selectedPolice.state}
                                              onChange={this.handleStateChange}
                                              inputProps={{
                                                  name: 'state',
                                                  id: 'state-helper',
                                              }}
                                      >
                                          
                                          {(this.state.selectedPolice.country == "U.S.A") && (usStates)}
                                          {(this.state.selectedPolice.country != "U.S.A") && (canStates)}
                                      
                                      
                                      </Select>
                                      {/* <FormHelperText>Select a State </FormHelperText> */}
                                  </FormControl>
                                  
                                  </Grid>
                                  <Grid item xs={5} sm={5}>
                                      <TextField required id="zip" name="zip" label="Zip / Postal code" fullWidth InputLabelProps={{ shrink: this.state.inputFieldShrinkState }} value={this.state.selectedPolice.zipcode} onChange={this.handleZipcodeChange} />
                                  </Grid>
                                  <Grid item xs={2} sm={2} >
                                  </Grid>
                                  <Grid item xs={5} sm={5}>
                                      {/*<TextField  required id="country"  name="country"  label="Country"  fullWidth  InputLabelProps={{ shrink: this.state.inputFieldShrinkState }}  value={this.state.selectedPolice.country} onChange={this.handleCountryChange} />
                                */} <FormControl className={classes.formControl}>
                                      <InputLabel htmlFor="age-helper">Country</InputLabel>
                                      <Select value={this.state.selectedPolice.country}
                                              onChange={this.handleCountryChange}
                                              inputProps={{
                                                  name: 'country',
                                                  id: 'country-helper',
                                              }}
                                      >
                                          
                                          {availableCountries}
                                      
                                      </Select>
                                  
                                  </FormControl>
                                  
                                  
                                  </Grid>
                                  
                                  
                                  
                                  <Grid item xs={5} sm={5}>
                                      <InputMask mask="(999) 999-9999" value={this.state.selectedPolice.phone} onChange={this.handlePhoneChange} >
                                          {() => <TextField required id="phone" name="phone" label="Phone" fullWidth InputLabelProps={{ shrink: this.state.inputFieldShrinkState }} />}
                                      </InputMask>
                                  </Grid>
                                  <Grid item xs={2} sm={2} >
                                  </Grid>
                                  
                                  <Grid item xs={5} sm={5}>
                                      <TextField required id="email" name="email" label="Email" fullWidth InputLabelProps={{ shrink: this.state.inputFieldShrinkState }} value={this.state.selectedPolice.email} onChange={this.handleEmailChange} />
                                  </Grid>
                                  
                                  
                                  <Grid item xs={5} sm={5}>
                                      <InputMask mask="(999) 999-9999" value={this.state.selectedPolice.fax} onChange={this.handleFaxChange} >
                                          {() => <TextField required id="phone" name="Fax" label="Fax" fullWidth InputLabelProps={{ shrink: this.state.inputFieldShrinkState }} />}
                                      </InputMask>
                                  </Grid>
                                  <Grid item xs={2} sm={2} >
                                  </Grid>
                                  
                                  <Grid item xs={5} sm={5}>
                                  
                                  </Grid>
                                  
                                  
                                  <Grid item xs={5} sm={5}>
                                  </Grid>
                                  <Grid item xs={2} sm={2} >
                                  </Grid>
                                  
                                  <Grid item xs={5} sm={5}>
                                  </Grid>
                                  
                                  <Grid item xs={5} sm={5}>
                                  </Grid>
                                  <Grid item xs={2} sm={2} >
                                  </Grid>
                                  
                                  <Grid item xs={5} sm={5}>
                                      {/* empty for now we can later*/}
                                  </Grid>
                                  
                                  
                                  
                                  <Grid item xs={6} sm={6}>
                                      {((this.state.selectedPolice.id === undefined) || (this.state.selectedPolice.id === "")) && (
                                        <Button variant="contained" color="primary" onClick={this.handleSubmit} className={classes.button}  >
                                            Add Police
                                        </Button>)}
                                  </Grid>
                                  <Grid item xs={6} sm={6}>
                                      {(  (this.state.selectedPolice.id !=='')) && (
                                        <Button variant="contained" color="primary" onClick={this.handleUpdate} className={classes.button}  >
                                            Update Police
                                        </Button>)}
                                  </Grid>
                                  <Grid item xs={6} sm={6}>
                                      <Button variant="contained" color="primary" onClick={this.clearFields} className={classes.button}  >
                                          Clear Fields
                                      </Button>
                                  </Grid>
                                  <Grid item xs={6} sm={6}>
                                      <Button variant="contained" color="primary" onClick={this.refresh} className={classes.button}  >
                                          Refresh
                                      </Button>
                                  </Grid>
                              </Grid>
                          </Grid>
                          <Grid item xs={1} sm={1}>
                          </Grid>
                          <Grid item xs={5} sm={5}>
                              {/*<DynamicTable  data={this.props.policeArray}  onEdit={this.editRecord}  onDelete={this.deleteRecord}> </DynamicTable> */}
                              <Typography variant="h6" gutterBottom>
                                  There are {this.props.policeArray.length}  Police Departments in your profile.
                              </Typography>
                              
                              <GridList cellHeight={100} className={classes.gridList}>
                                  {this.policeCardList}
                              </GridList>
                          </Grid>
                      </Grid>
                      
                      
                      
                      <Grid container >
                          {/*{(this.props.errorCMsg) && (this.props.errorCMsg.message) && (
                                <Grid item xs={12}   >
                                    <TextField error id="outlined-error" label="Error - Operation Failed" value={" message = " + this.props.errorCMsg.message + " details = " + this.props.errorCMsg.details + " Time = " + this.props.errorCMsg.timestamp}
                                        className={classes.textField} margin="normal" variant="outlined" disabled={true} multiline={true} />
                                </Grid>)
                            } */}
                          {/*
                    {  !this.props.errorCMsg && (
                    <Grid item xs={12}   >
                        <TextField error id="outlined-error" label="Great! - Operation Success" value= "Nothing here"
                        className={classes.textField} margin="normal"  variant="outlined" disabled={true}  multiline={true}/>
                    </Grid>)
                    }
                    */}
                      </Grid>
                  </Grid>
                  {/* This is for submit event error/success display */}
                  <Dialog
                    open={this.state.showPoliceSavedDialog}
                    onClose={this.handleClickShowSavedPoliceClose}
                    scroll={'paper'}
                    classes={{
                        paper: classes.formControl2,
                    }}
                    aria-labelledby="scroll-dialog-title"
                    aria-describedby="scroll-dialog-description"
                    maxWidth="xl"
                  >
                      <DialogTitle id="scroll-dialog-title">Police Information</DialogTitle>
                      <DialogContent id="farshids" dividers="paper">
                          
                          {(this.props.errorCMsg.status == 200) && (<div>
                              The Operation was SUCCESSFUL! Please refresh the list by pressing the refresh button -  {this.props.errorCMsg.status}  {this.props.errorCMsg.statusText}
                          </div>)}
                          {(this.props.errorCMsg.status != 200) && (this.props.errorCMsg.status != null) && (<div>
                              The Operation FAILED, please try again! -  {this.props.errorCMsg.status} - {this.props.errorCMsg.statusText}
                          </div>)}
                      
                      </DialogContent>
                      <DialogActions>
                          {/*
																										<Tooltip title="Selected entities will receive police notice">
																											<Button  color="primary" onClick={this.sendEmail}>Send EMAIL</Button>
																										</Tooltip>
																										*/}
                          
                          <Button onClick={this.handleClickShowSavedPoliceClose} color="secondary">Close</Button>
                      </DialogActions>
                  </Dialog>
              
              
              
              </Grid>
          </React.Fragment>
        );
    }//end of render
    
    
    
    editRecord(singleRowData) {
        this.setState({ inputFieldShrinkState: true });
        this.setState({ selectedPolice: singleRowData });
        //We need to change the seleted Location as well.
        //let tempLocation = this.props.locationsArray.find(x => x.locationId == singleRowData.locationId );
        
        //this.setState({selectedLocation:tempLocation });
        
    }
    
    
    deleteRecord(argProcessId) {
        let { deleteAPolice } = this.props;
        deleteAPolice(DEFAULT_VESPAAN_SERVER.url, argProcessId, this.state.selectedCompany.id);
    }
    
    
    componentWillMount() {
        let { loadPoliceData, loadCompanysData } = this.props;
        //loadPoliceData(DEFAULT_VESPAAN_SERVER.url, this.state.selectedCompany.id );
        //loadLocationsData("http://localhost:9065/" );
        
        loadCompanysData(DEFAULT_VESPAAN_SERVER.url);
        
        this.setState({
            errorCMsg: {}
        });
        
        if ((this.props.companysArray != null) && (this.props.companysArray.length >= 1)) {
            this.setState({ selectedCompany: this.props.companysArray[0] });
            loadPoliceData(DEFAULT_VESPAAN_SERVER.url, this.props.companysArray[0].id);
        }
        
        
        
    }
    
    
    componentDidMount() {
        /*if((this.props.companysArray != null)  && (this.props.companysArray.length >= 1) ){
            this.setState({selectedCompany: this.props.companysArray[0]});
        }*/
        
    }
    
    
    componentWillReceiveProps(nextProps) {
        if (this.props.policeArray !== nextProps.policeArray) {
            this.setState({
                policeArray: nextProps.policeArray
            });
        }
        if ((nextProps != null) && (nextProps.companysArray != null) && (nextProps.companysArray.length >= 1) && (this.props.companysArray !== nextProps.companysArray)) {
            this.setState({ selectedCompany: nextProps.companysArray[0] });
            //selectACompany(nextProps.companysArray[0].id);
        }
        
        
        if (nextProps.errorCMsg.status != null) {
            if (nextProps.errorCMsg.status != null) {
                this.handleClickShowSavedPolice();
            }
        }
        
        
        
    }
    
    
    
}//end of class

PoliceInfoForm.propTypes = {
    classes: PropTypes.object.isRequired,
};

const mapStateToProps = (state) => {
    return {
        policeArray: state.police.policeArray,
        PoliceDeleteResponse: state.police.deletePoliceResp,
        PoliceSaveResponse: state.police.savePoliceResp,
        companysArray: state.company.companysArray,
        //locationsArray:state.location.locationsArray,
        //vcArray:state.videocontroller.vcArray,
        //camerasArray:state.camera.camerasArray,
        errorCMsg: state.police.errorCMsg,
    };
};

const mapDispatchToProps = (dispatch) => {
    return bindActionCreators({
        loadPoliceData: loadPoliceData,
        deleteAPolice: deleteAPolice,
        saveAPolice: saveAPolice,
        updateAPolice: updateAPolice,
        loadCompanysData: loadCompanysData,
        clearPoliceErrorMsg: clearPoliceErrorMsg,
        
    }, dispatch);
};

export default connect(mapStateToProps, mapDispatchToProps)(withStyles(styles)(PoliceInfoForm));
